// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"348":"b4293e07","624":"b617dcdf","694":"e84a93c5","708":"35913cf5","808":"a0a142a7"}[chunkId] + ".chunk.js";
};